module.exports = __webpack_public_path__ + "static/media/murphy.fa307262.png";